export default "__VITE_ASSET__ClVNVaBP__"